export default __webpack_public_path__ + "static/media/badges.4325b612.png";